import { css } from '@emotion/css';

export const textContainerStyles = css`
  max-width: 24rem;
`;
